import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { limpiarSesion } from "@/lib/sesionTokens";
import "./UserButton.css";

export const UserButton = ({ userName }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  // Función para manejar el clic en el botón de cerrar sesión
  const handleLogout = () => {
    // CA-7: limpia las claves de sesión JWT real (accessToken/refreshToken,
    // ver src/lib/sesionTokens.js) además del token invitado y el estado de
    // usuario — ninguna request posterior debe llevar rastro de la sesión
    // anterior. El reload sigue siendo lo que garantiza que useCheckToken
    // vuelva a pedir un token invitado (S7); con auth-storage borrado, el
    // store queda en `pending`/invitado, habilitando el checkout de invitado
    // sin recarga manual adicional (CA-7bis).
    limpiarSesion();
    // Modo privado / cuota llena: removeItem puede lanzar (mismo caso borde 2
    // que sesionTokens.js/ModalCredential.jsx) — no debe cortar el logout a
    // mitad de camino y dejar al usuario sin poder cerrar sesión.
    try {
      localStorage.removeItem("token");
      localStorage.removeItem("rut");
      localStorage.removeItem("auth-storage");
    } catch {
      // no-op: seguimos igual a navegar y recargar.
    }
    setIsMenuOpen(false); // Cierra el menú
    navigate("/login"); // Redirige a la página de inicio de sesión
    window.location.reload();
  };

  // Función para cerrar el menú al hacer clic fuera de él
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const handleToggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="user-dropdown-container" ref={dropdownRef}>
      {/* El botón que al hacer clic abrirá/cerrará el menú */}
      <button className="user-profile-btn" onClick={handleToggleMenu}>
        <i className="icon-user-menu"></i>
        <span className="user-name">{userName}</span>
        <i className={`icon-arrow-down-menu ${isMenuOpen ? "open" : ""}`} />
      </button>

      {/* El menú desplegable, que se muestra condicionalmente */}
      {isMenuOpen && (
        <div className="dropdown-menu-user">
          <button className="dropdown-item-user" onClick={handleLogout}>
            {/* <FontAwesomeIcon icon={faSignOutAlt} className="menu-icon" /> */}
            Cerrar sesión
          </button>
        </div>
      )}
    </div>
  );
};
